import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.clubUser}/v4/bulkActions`, {
  post: {
    'resend.access': '/resendAccess'
  }
});
